type OpenReportParams = {
  organizationGuid?: string;
  personGuid?: string;
  [key: string]: string | undefined;
};

const openReport = (
  uri: string,
  { organizationGuid = '', personGuid = '', ...extraParams }: OpenReportParams,
): void => {
  const url = new URL(uri);
  const { searchParams } = url;

  if (organizationGuid) {
    searchParams.set('OrganizationGUID', organizationGuid);
  }

  if (personGuid) {
    searchParams.set('PersonGUID', personGuid);
  }

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, value);
    }
  });

  url.search = searchParams.toString();

  window.open(url.toString(), '_blank');
};

export default openReport;

export function openReportWithQueryParams(
  uri: string,
  {
    organizationGuid = '',
    ...extraParams
  }: { organizationGuid: string; [key: string]: string | number },
): void {
  const url = new URL(uri);
  const { searchParams } = url;

  if (organizationGuid) {
    searchParams.set('OrganizationGUID', organizationGuid);
  }

  if (extraParams) {
    for (const key in extraParams) {
      const value = extraParams[key];

      if (value !== undefined && value !== null) {
        searchParams.set(key, String(value));
      }
    }
  }

  const finalUrl = url.toString();
  window.open(finalUrl, '_blank');
}
